import { faDownload /* faFileDownload */ } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HICLoading } from 'hic-components'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'
import FormLayout from 'src/app/layout/form-layout/form-layout'
import { FormLayoutDefaultToolbar } from 'src/app/layout/form-layout/form-layout-toolbar'
import { PAGE_WIDTH } from '../page/page'

type ReportViewerProps = {
  title: string
  reportFile?: string
  isLoading?: boolean
  pdfToolbarOff?: boolean
  open: boolean
  setClose: () => void
  /**
   * - sm = 600px
   * - md = 800px
   * - lg = normal page width 1280px (default)
   * - fullWidth = 100%
   **/
  size?: 'sm' | 'md' | 'lg' | 'fullWidth'
}

export default function ReportViewer(props: ReportViewerProps) {
  const { t } = useTranslation()
  const { title, reportFile, isLoading, open, setClose } = props
  const { lg } = useBreakpoints()

  const width = useMemo(() => {
    if (props.size) {
      switch (props.size) {
        case 'sm':
          return '600px'
        case 'md':
          return '800px'
        case 'lg':
          return PAGE_WIDTH
        case 'fullWidth':
          return '100%'
      }
    } else return PAGE_WIDTH
  }, [props.size])

  return (
    <>
      <FormLayout //
        title={title}
        appearance={{ type: 'DRAWER', open: open, onClose: setClose, width: lg ? width : '100%' }}
        toolbar={
          <FormLayoutDefaultToolbar
            cancelButton={{
              clickHandler: setClose,
              text: t('commons.close'),
            }}
            saveButton={{
              text: t('commons.download_pdf'),
              startIcon: <FontAwesomeIcon icon={faDownload} />,
              clickHandler: () => {
                if (reportFile) {
                  window.open(reportFile, '_blank')
                }
              },
            }}
          />
        }
      >
        <span>
          {isLoading && <HICLoading />}
          {reportFile && <iframe src={`${reportFile}#toolbar=1&view=fitH`} width="100%" style={{ height: 'calc(100% - 25px)' }} />}
          {/* reportFile && (
            <span>
              <a href={reportFile} target="_blank">
                <FontAwesomeIcon icon={faFileDownload} style={{ width: 24 }} />
                Download file
              </a>
            </span>
          ) */}
        </span>
      </FormLayout>
    </>
  )
}
